import { call, put, takeLatest } from "redux-saga/effects";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import {
  FETCH_DASHBOARD_ACTIVITY_LIST_REQUEST,
  FETCH_DASHBOARD_AVG_DETAILS_REQUEST,
} from "./actionTypes";
import {
  fetchDashboardActivityListFailure,
  fetchDashboardActivityListSuccess,
  fetchDashboardAvgDetailsFailure,
  fetchDashboardAvgDetailsSuccess,
  fetchDashboardDateRangeListFailure,
  fetchDashboardDateRangeListSuccess,
} from "./actions";
import {
  DashboardActivityAvgDetails,
  DashboardActivityList,
  DashboardDateRangeActivityList,
} from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchDashboardActivityList(action: any) {
  try {
    const data: DashboardActivityList[] | DashboardDateRangeActivityList[] =
      yield call(postRequest, action.url, action.payload);

    if (action.payload.searchBy === "CUSTOMERORVENDOR") {
      yield put(fetchDashboardActivityListSuccess(data));
    } else {
      yield put(fetchDashboardDateRangeListSuccess(data));
    }
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || "An error occurred";
    if (action.payload.searchBy === "CUSTOMERORVENDOR") {
      yield put(fetchDashboardActivityListFailure(errorMessage));
    } else {
      yield put(fetchDashboardDateRangeListFailure(errorMessage));
    }
  }
}

function* fetchDashboardAvgDetails(action: any) {
  try {
    const response: DashboardActivityAvgDetails = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(fetchDashboardAvgDetailsSuccess(response));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || "An error occurred";
    yield put(fetchDashboardAvgDetailsFailure(errorMessage));
  }
}

export default function* dashboardSaga() {
  yield takeLatest(
    FETCH_DASHBOARD_ACTIVITY_LIST_REQUEST,
    fetchDashboardActivityList
  );
  yield takeLatest(
    FETCH_DASHBOARD_AVG_DETAILS_REQUEST,
    fetchDashboardAvgDetails
  );
}
